import { Alert, Link } from '@mui/material'

interface UserCapAlertProps {
  userCap: number
}

export function UserCapAlert({ userCap }: UserCapAlertProps) {
  return (
    <Alert severity="warning" className="mb-4">
      The user cap for this linked service ({userCap}) has been reached. To
      increase your user limit, please{' '}
      <Link
        href="mailto:support@foamfrat.com"
        color="inherit"
        underline="always"
      >
        contact support
      </Link>
      .
    </Alert>
  )
}
